import { composer } from '../../../component-decorators/composer';
import { Text } from 'wix-style-react';
import React from 'react';
import { AppGroup } from "@wix/ambassador-marketplace/types";
import { usePremiumCurrencyFormatter } from "@wix/premium-react-text";
export var PriceBadge = composer()
    .withExperiments()
    .withTranslation()
    .compose(function (_a) {
    var _b;
    var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var t = _a.t, app = _a.app, experiments = _a.experiments;
    var fixedPrice = app.appSavedPrice && app.appSavedPrice !== 0
        ? Number(app.appSavedPrice).toFixed(2)
        : '';
    // tslint:disable-next-line:react-hooks-nesting
    var currencyToString = usePremiumCurrencyFormatter({ currencySettings: (_b = {},
            _b[(_d = (_c = app.webSolutionBase.pricing) === null || _c === void 0 ? void 0 : _c.currencySettings) === null || _d === void 0 ? void 0 : _d.code] = {
                symbol: (_f = (_e = app.webSolutionBase.pricing) === null || _e === void 0 ? void 0 : _e.currencySettings) === null || _f === void 0 ? void 0 : _f.symbol,
                decimalSep: (_h = (_g = app.webSolutionBase.pricing) === null || _g === void 0 ? void 0 : _g.currencySettings) === null || _h === void 0 ? void 0 : _h.decimalSeparator,
                groupSep: (_k = (_j = app.webSolutionBase.pricing) === null || _j === void 0 ? void 0 : _j.currencySettings) === null || _k === void 0 ? void 0 : _k.groupSeparator,
                negPrefix: (_m = (_l = app.webSolutionBase.pricing) === null || _l === void 0 ? void 0 : _l.currencySettings) === null || _m === void 0 ? void 0 : _m.negativePrefix,
                negSuffix: (_p = (_o = app.webSolutionBase.pricing) === null || _o === void 0 ? void 0 : _o.currencySettings) === null || _p === void 0 ? void 0 : _p.negativeSuffix,
                posPrefix: '¤',
                posSuffix: '',
                fractionSize: 2,
            },
            _b), currencyCode: (_r = (_q = app.webSolutionBase.pricing) === null || _q === void 0 ? void 0 : _q.currencySettings) === null || _r === void 0 ? void 0 : _r.code })[0];
    var showFullPrices = experiments.enabled('specs.marketplace.fullPrices');
    var savedPrice = showFullPrices ? currencyToString(Number(fixedPrice)) : "$" + fixedPrice;
    return app.group === AppGroup.BUNDLE ? (React.createElement("div", null,
        fixedPrice !== '' && (React.createElement("span", { style: { textDecoration: 'line-through' } },
            React.createElement(Text, { size: "small", weight: "thin", secondary: true }, savedPrice))),
        React.createElement("span", { style: { marginLeft: '6px' } },
            React.createElement(Text, { size: "small", weight: "thin", skin: "success", secondary: true }, t('manage-apps.app-price.free'))))) : (React.createElement("div", null));
});
//# sourceMappingURL=price-badge.js.map